import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import SearchResults from "./SearchResults";
import SearchField, { Hint } from "./SearchField";
import { useOnClickOutside, useSearch } from "./hooks";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { ModuleEnum, SearchResultAvatarDto } from "./types";

export type SearchFieldProps = {
  endpoint: string;
};

const SearchWrapper = styled.div`
  font-family: ${(props) => props.theme.fonts.normal};
`;

function getDocumentPreviewUrl(avatarDto: SearchResultAvatarDto): string {
  return `/app/employees/${avatarDto.uuid}/contract/${avatarDto.contractId}?detailsTab=5&fileUrl=${avatarDto.fileUrl}&fileType=${avatarDto.fileContentType}&fileName=${avatarDto.fileName}&documentUuid=${avatarDto.documentId}`;
}

const Search: React.FC<SearchFieldProps> = ({ endpoint }) => {
  const searchRef = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const { t } = useTranslation("general");
  const { searchState, handleSearch, clearSearch } = useSearch(endpoint);
  const { searchTerm, data, loading, error } = searchState;
  const [isVisibleResults, setIsVisibleResults] = useState(false);
  const showHint = searchTerm.length > 0 && searchTerm.length < 3;

  useOnClickOutside(searchRef, () => setIsVisibleResults(false));

  return (
    <SearchWrapper ref={searchRef}>
      <SearchField
        onFocus={() => setIsVisibleResults(true)}
        searchTerm={searchTerm}
        onSearch={handleSearch}
      />
      {isVisibleResults && (
        <SearchResults
          searchTerm={searchTerm}
          onResultItemClick={(
            avatarDto: SearchResultAvatarDto,
            module: ModuleEnum
          ) => {
            if (module === ModuleEnum.DPF) {
              history.push(
                `/app/employees/${avatarDto.uuid}/contract/${avatarDto.contractId}`
              );
            } else if (module == ModuleEnum.DOCUMENTS) {
              history.push(getDocumentPreviewUrl(avatarDto));
            } else if (module === ModuleEnum.REPORTS) {
              history.push(`/app/reporting/${avatarDto.uuid}/view`);
            }
            clearSearch();
          }}
          loading={loading}
          items={data}
          hasError={error}
        />
      )}
      {showHint ? <Hint>{t("search.hint", { minLength: 3 })}</Hint> : null}
    </SearchWrapper>
  );
};

export default Search;
